export const primaryColor = '#C3073f';
export const primaryDarkColor = '#1A1A1D';

export const successColor = '#0197F6';
export const inforColor = '#0197F6';
export const errorColor = '#F2AF29';
export const warningColor = '#F2AF29';
